<template>
  <div style="width: 100%">
    <!-- Start card for float effect -->
    <v-card class="TableWrapper scroll-horizontal-table">
      <!-- Start simple table -->
      <v-simple-table fixed-header height="490px">
        <template v-slot:default>
          <thead v-if="!bLoading">
            <tr>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                #
              </th>
              <th
                class="text-center"
                style="border-bottom: 3px solid #e4e4e4"
              ></th>
              <th class="text-center " style="border-bottom: 3px solid #e4e4e4">
                Nombre
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Correo eletrónico
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Puesto
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Proyectos
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Gestión de gastos
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Solicitudes de material
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Órdenes de compra
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Gestión de O.C
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Proveedores
              </th>
              <th class="text-center" style="border-bottom: 3px solid #e4e4e4">
                Usuarios
              </th>
              <th
                class="text-center"
                style="border-bottom: 3px solid #e4e4e4; width: 130px"
              >
                Acción
              </th>
            </tr>
          </thead>
          <tbody v-if="!bLoading">
            <tr v-for="(item, index) in items" :key="index">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">
                <div
                  v-if="item.bAdminPermission"
                  class="pointer-admin-permission"
                ></div>
              </td>
              <td class="text-center W-S-nowrap">{{ item.sFullName }}</td>
              <td class="text-center">{{ item.sEmail }}</td>
              <td class="text-center">{{ item.sPosition }}</td>
              <td
                class="text-center"
                v-for="(pItem, pIndex) in setRoles(
                  item.aPermissions.map((e) => e.sName)
                )"
                :key="pIndex"
              >
                <v-icon v-if="pItem == 'check'" color="#8CE3AD"
                  >mdi-check</v-icon
                >
                <v-icon v-else color="#FF8282">mdi-close</v-icon>
              </td>

              <td class="text-center" style="white-space: nowrap">
                <div>
                  <v-btn icon color="black" @click="setEditUser(item.sUserId)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="#FF5757" @click="deleteProjects(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
          <div v-show="bLoading">
            <v-progress-linear
              indeterminate
              color="yellow darken-2"
            ></v-progress-linear>
            <div class="content-text-loading">
              <p class="text-loading">Cargando... Espere por favor</p>
            </div>
          </div>
        </template>
      </v-simple-table>
      <div class="footer-table">
        <div style="margin-right: 30px">
          <p>
            Filas por página:
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="footer-table-dropdown"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ iItemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="changeTableContacts(10)">
                  <v-list-item-title>10</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeTableContacts(25)">
                  <v-list-item-title>25</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeTableContacts(50)">
                  <v-list-item-title>50</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeTableContacts(100)">
                  <v-list-item-title>100</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </p>
        </div>
        <div style="margin-right: 15px">
          <p>{{ iCurrentPage }}-{{ numPages }} de {{ totalItems }}</p>
        </div>
        <div>
          <v-btn
            elevation="0"
            class="footer-table-buttons"
            @click="backPageContacts"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            elevation="0"
            class="footer-table-buttons"
            @click="nextPageContacts"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- End simple table -->
      <!-- Start pagination -->

      <!-- End pagination -->
    </v-card>
    <ChangepasswordDialog
      @close="openDialogChangePass = false"
      :openDialogChangePass="openDialogChangePass"
      :itemDetails="itemDetails"
    ></ChangepasswordDialog>
    <ViewDetails
      @close="openDialogDetails = false"
      :openDialogDetails="openDialogDetails"
      :itemDetails="itemDetails"
      @openDialogChangePassword="openDialogChangePassword"
    ></ViewDetails>
    <!-- End card for float effect -->
  </div>
</template>
<script>
import ChangepasswordDialog from "@/components/views/Users/ChangePassword";
import ViewDetails from "@/components/views/Users/Details";

export default {
  data() {
    return {
      bLoading: false,
      // number of pages
      iCurrentPage: 1,
      iPageNumber: 1,
      // store db items (Pickers)
      mainstatus: "En proceso",
      Estatus: ["En proceso", "Detenido", "Terminado"],
      items: [],
      rolUser: [],
      iItemsPerPage: 50,
      numPages: 0,
      totalItems: 0,
      openDialogDetails: false,
      itemDetails: {},
      openDialogDelete: false,
      itemDelete: {},
      openDialogChangePass: false,
    };
  },
  beforeMount() {
    this.$store.commit("setStatus", null);
  },
  mounted() {
    this.getItems();
    this.getRoles();
  },
  components: {
    ViewDetails,
    ChangepasswordDialog,
  },
  computed: {
    // return headers from texts
    arrHeaders() {
      return this.texts.headers;
    },
    // set search variable for filter option
    sSearch() {
      return this.$store.state.sSearch;
    },
    startDate() {
      return this.$store.state.dStartDate;
    },
    endDate() {
      return this.$store.state.dEndDate;
    },
    sStatus() {
      return this.$store.state.sStatus;
    },
    sArea() {
      return this.$store.state.sArea;
    },
    token() {
      return "Bearer " + this.$store.state.token;
    },
    refreshTable() {
      return this.$store.state.refresh;
    },
  },
  watch: {
    sArea: function() {
      this.iCurrentPage = 1;
      this.getItems();
    },
    sStatus: function() {
      this.iCurrentPage = 1;
      this.getItems();
    },
    sSearch: function() {
      this.iCurrentPage = 1;
      this.getItems();
    },
    endDate: function() {
      if (this.endDate) {
        this.iCurrentPage = 1;
        this.getItems();
      }
    },
    startDate: function() {
      this.iCurrentPage = 1;
      this.getItems();
    },
    iCurrentPage: function() {
      this.getItems();
    },
    refreshTable: function() {
      this.getItems();
    },
  },
  methods: {
    openDialogChangePassword(e) {
      this.openDialogChangePass = true;
      this.itemDetails = e;
    },
    setRoles(e) {
      let roles = this.rolUser.length;
      let users = e.length;
      let rellenar = roles - users;
      const ordenado = [
        "Projects",
        "ExpenseManagement",
        "RequestForMaterials",
        "PurchaseOrder",
        "ManagementPurchaseOrders",
        "Supplier",
        "PurchaseUser",
      ];
      const closes = [
        "close",
        "close",
        "close",
        "close",
        "close",
        "close",
        "close",
      ];
      for (let i = 0; i < rellenar; i++) {
        e.push("close");
      }

      for (let i = 0; i < ordenado.length; i++) {
        if (ordenado.find((callback) => callback == e[i])) {
          closes.splice(ordenado.indexOf(e[i]), 1, "check");
        }
      }

      return closes;
    },
    mask(price) {
      const nf = new Intl.NumberFormat("en-US");
      let number = nf.format(price);
      return price % 1 === 0 ? (number = number + ".00") : number;
    },
    viewDetails(e) {
      this.openDialogDetails = true;
      this.itemDetails = e;
    },
    setEditUser(sIdUser) {
      this.$router.push({
        name: "AddOrEditUser",
        params: { sIdUser: sIdUser },
      });
    },
    deleteProjects(item) {
      this.$store.commit("setDeleteItems", {
        id: item.sUserId,
        route: "/api/v1/users/" + item.sUserId,
        unit: " usuarios.",
        msgDelete: "Estás a punto de eliminar un elemento",
        msgQuestionDelete: "¿Estás seguro que deseas realizar esta acción?",
      });
    },
    changeTableContacts(e) {
      this.iItemsPerPage = e;
      this.iCurrentPage = 1;
      this.getItems();
    },
    backPageContacts() {
      if (this.iCurrentPage > 1) {
        this.iCurrentPage--;
      }
    },
    nextPageContacts() {
      if (this.iCurrentPage < this.numPages) {
        this.iCurrentPage++;
      }
    },
    // get the items from api
    getItems() {
      this.bLoading = true;
      // get items
      db.get(`${uri}/api/v1/users`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
        params: {
          iPageNumber: this.iCurrentPage,
          sSearch: this.sSearch,
          iItemsPerPage: this.iItemsPerPage,
          sArea: this.sArea,
          sProjectStatusId: this.sStatus,
        },
      })
        .then((resp) => {
          this.numPages = resp.data.iNumPages;
          this.iPageNumber = resp.data.iNumPages;
          this.items = resp.data.users.filter((e) => {
            if (!e.aPermissions.map((e) => e.sName).includes("Administrator")) {
              return e;
            }
          });
          this.totalItems = resp.data.iTotal;
          this.bLoading = false;

          this.$store.commit("refresher", false);
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
    // get the items from api
    getRoles() {
      this.bLoading = true;
      // get items
      db.get(`${uri}/api/v1/roles/`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-tk"),
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((resp) => {
          this.rolUser = resp.data.roles.filter((e) => {
            if (!e.sName.includes("Administrator")) {
              return e;
            }
          });
        })
        .catch((err) => {
          this.bLoading = false;
          const alert = {
            color: "red",
            text: err.response.data.message,
          };
          this.$store.commit("toggle_alert", alert);
        });
    },
  },
  props: {
    // import texts from admin
    texts: Object,
    mdUp: Boolean,
    smUp: Boolean,
  },
};
</script>
<style>
.scroll-horizontal-table {
  overflow-x: auto !important;
  display: block;
  width: 100% !important;
}
</style>

<style scoped>
.pointer-admin-permission {
  width: 10px;
  border-radius: 100%;
  background-color: #ffce00;
  height: 10px;
}
.footer-table-dropdown {
  opacity: 0.54;
  color: #475f7b;
  font-size: 12px;
  letter-spacing: 0;
}

.table-contacts thead {
  background-color: #f7f8ff;
}

.table-contacts thead tr th {
  border-bottom: 1px solid #f7f8ff !important;
  color: #47567b !important;
  opacity: 0.87;
  font-size: 13px !important;
  letter-spacing: 0;
  line-height: 15px;
  font-weight: 500;
}

.table-contacts tbody tr td {
  color: #250e62;
  opacity: 0.87;
  font-size: 13px !important;
  letter-spacing: 0;
  border-bottom: 0.5px solid #979797 !important;
}

.footer-table {
  background-color: #fff;
  height: 56px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.footer-table p {
  margin-bottom: 0;
  color: #696969;
  font-size: 12px;
  letter-spacing: 0;
}

.footer-table-buttons {
  background-color: #fff !important;
}

.footer-table-buttons i {
  font-size: 24px;
  opacity: 0.54;
  color: #475f7b !important;
}

.actionsIcon {
  font-size: 20px !important;
}
.TableWrapper {
  padding: 15px;
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 40px #00000019 !important;
  border-radius: 20px !important;
  width: 100%;
  margin-bottom: 25px;
}
</style>
